import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

export const theme = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{blue.50}',
            100: '{blue.100}',
            200: '{blue.200}',
            300: '{blue.300}',
            400: '{blue.400}',
            500: '{blue.500}',
            600: '{blue.600}',
            700: '{blue.700}',
            800: '{blue.800}',
            900: '{blue.900}',
            950: '{blue.950}',
        },
        colorScheme: {
            light: {
                surface: {
                    0: '#ffffff',
                    50: '{zinc.50}',
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}',
                },
                formField: {
                    hoverBorderColor: '{primary.color}',
                },
            },
            dark: {
                surface: {
                    0: '#ffffff',
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}',
                },
                formField: {
                    hoverBorderColor: '{primary.color}',
                },
            },
        },
    },
    components: {
        panelmenu: {
            panel: {
                background: 'transparent',
                borderColor: 'transparent',
                borderWidth: '0',
                padding: '0',
            },
            item: {
                color: '#cbd5e1',
                focusBackground: 'rgba(255,255,255,0.1)',
                focusColor: '#ffffff',
                padding: '0.6rem 1rem',
                borderRadius: '0.375rem',
                icon: {
                    color: '#94a3b8',
                    focusColor: '#ffffff',
                },
            },
        },
    },
});
